import {ChartType} from 'common/report/constants';
import {ShowClause} from 'common/report/insights/models/clause';
import {FormulaSection} from 'common/report/insights/models/section';
import {ChartPlotStyle} from 'common/report/insights/util/types';
import {Report} from 'common/report/insights/models/report';

import {Formula, formulaToFormulaClause} from './types';

export function updateReportFormulaSection({report, formulas}: {report: Report; formulas: Formula[]}): Report {
  report = report.clone();

  const clauses = formulas.map(formulaToFormulaClause);
  const formulaSection = FormulaSection.create(FormulaSection.TYPE, clauses);
  report.sections = report.sections.replaceSection(formulaSection);

  report = updateReportFormulaLabels(report);
  return report;
}

export function updateReportFormulaLabels(report: Report): Report {
  report = report.clone();

  if (report.sections.formula.hasClauses()) {
    report.sections = report.sections.replaceSection(report.sections.show.addFormulaLabels());
  } else {
    report.sections = report.sections.replaceSection(report.sections.show.removeFormulaLabels());
  }
  return report;
}

export function getFormulaDisabledReason(report: Report) {
  const {displayOptions, sections} = report;

  if (report.isEmpty()) {
    return `To add a formula, you must select an event first`;
  }

  if (displayOptions && displayOptions.chartType === ChartType.Pie) {
    return `Formulas is not available when using pie chart`;
  }

  if (sections.show.clauses.some((c) => c.value.name === ShowClause.TOP_EVENTS.name)) {
    return `To add a formula, select something other than "Your Top Events"`;
  }

  if (displayOptions && displayOptions.plotStyle === ChartPlotStyle.Stacked) {
    return `Formulas is not available when using stacked chart`;
  }

  return ``;
}
